/**
 * Creates a storage adapter for web platform
 * Returns native localStorage/sessionStorage (synchronous API)
 * Falls back to in-memory storage if browser storage is unavailable
 *
 * @param {String} _storage - Storage type: "local" or "session"
 * @returns {Storage} Storage object with getItem/setItem/removeItem methods
 */
const Store = (_storage = "local") => {
  try {
    let storage;
    switch (_storage) {
      case "local":
        storage = localStorage;
        break;
      case "session":
        storage = sessionStorage;
        break;
      default:
        storage = localStorage;
    }

    // Test if storage is actually available (fails in private browsing, etc.)
    const testKey = "__storage_test__";
    storage.setItem(testKey, "test");
    storage.removeItem(testKey);

    return storage;
  } catch (error) {
    console.warn("Browser storage not available, using in-memory fallback:", error);

    // In-memory fallback storage (same sync API as localStorage)
    const memoryStorage = {};
    return {
      getItem: (key) => memoryStorage[key] || null,
      setItem: (key, value) => {
        memoryStorage[key] = String(value);
      },
      removeItem: (key) => {
        delete memoryStorage[key];
      },
      clear: () => {
        Object.keys(memoryStorage).forEach((k) => delete memoryStorage[k]);
      },
      get length() {
        return Object.keys(memoryStorage).length;
      },
      key: (index) => Object.keys(memoryStorage)[index] || null,
    };
  }
};

export { Store };
